module.exports = __webpack_public_path__ + "img/IMG_0838.b68a56d8.jpeg";